import { ChangeDetectionStrategy, AfterViewInit, Component, inject } from '@angular/core';
import {AuthGuardService} from '../../common/services/auth-guard.service';
import {Router} from '@angular/router';
import {Localization} from '../../../../projects/common/src/lib/interface/localization.extension';
import {StringsService} from '../../../../projects/common/src/lib/services/strings.service';
import {Title} from '@angular/platform-browser';
import {CommonUtil} from '../../common/utils/common.util';


@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
  selector: 'app-403-unauthorized',
  templateUrl: '403-unauthorized.page.html',
  styleUrls: ['../../styles/common.scss', '403-unauthorized.page.scss']
})
export class UnathorizedPage extends Localization implements AfterViewInit {
  private authGuard = inject(AuthGuardService);
  private router = inject(Router);
  private titleService = inject(Title);


  constructor() {

    super();
  }

  ngAfterViewInit(): void {
    this.titleService.setTitle(this.getString('unauthorized'));
    this.authGuard.loader.set(false);
    this.authGuard.loader$.next(false);
  }

  goToDashboard() {
    this.router.navigateByUrl('/dashboard');
  }

  isInIframe() {
    return CommonUtil.inIframe();
  }
}
